import { ImageContainer } from '../InfoTitle/InfoTitle';
import styled from 'styled-components';
import { LinkButton } from '../Button/LinkButton';

const MiniUserProfile = styled.div`
  ${ImageContainer} {
    align-self: flex-start;
    margin-right: ${({ theme }) => theme.spacing.S8};
    width: 48px;
  }
`;

const FranchiseButton = styled(LinkButton)`
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

export { MiniUserProfile, FranchiseButton };
